import React, { useMemo } from 'react';
import { Marker, Popup } from 'react-leaflet';
import { Icon } from 'leaflet';
import { useTranslation } from 'react-i18next';
import { isInHaiti } from '../../utils/locationUtils';

interface UserLocationMarkerProps {
  position: { lat: number; lng: number };
}

export default function UserLocationMarker({ position }: UserLocationMarkerProps) {
  const { t } = useTranslation();

  // Check if user is in Haiti
  const userIsInHaiti = isInHaiti(position.lat, position.lng);
  
  // Only render the marker if user is in Haiti
  if (!userIsInHaiti) return null;

  // Memoize the icon to prevent recreating it on every render
  const icon = useMemo(() => new Icon({
    iconUrl: '/markers/marker-icon.png',
    iconRetinaUrl: '/markers/marker-icon-2x.png',
    shadowUrl: '/markers/marker-shadow.png',
    iconSize: [27, 44],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
    className: 'user-location-marker'
  }), []); // Empty dependency array since icon config never changes

  // Only render if we have valid coordinates
  if (!position || typeof position.lat !== 'number' || typeof position.lng !== 'number') {
    return null;
  }

  return (
    <Marker position={[position.lat, position.lng]} icon={icon}>
      <Popup>
        <div className="text-center">
          <strong>{t('incident.details.yourLocation')}</strong>
        </div>
      </Popup>
    </Marker>
  );
}